<template>
  <b-taginput
    open-on-focus
    :value="value"
    @input="v => $emit('input', v)"
    :data="filteredOptions"
    autocomplete
    icon="label"
    :placeholder="placeholder"
    @typing="getFilteredOptions">
  </b-taginput>
</template>

<script>
export default {
  props: {
    value: Array,
    options: Array,
    placeholder: {
      type: String,
      default: 'Click to see options',
    },
  },
  data() {
    return {
      filteredOptions: null,
    };
  },
  methods: {
    getFilteredOptions(text = '') {
      this.filteredOptions = this.options.filter(option => option
        .toString()
        .toLowerCase()
        .indexOf(text.toLowerCase()) >= 0);
    },
  },
  created() {
    this.getFilteredOptions();
  },
};
</script>
